/**
 * FAQ Accordion for H3 Questions and P Answers
 * Converts H3 tags to clickable questions that show/hide following paragraphs
 */

(function() {
  'use strict';

  // Wait for page to load
  document.addEventListener('DOMContentLoaded', function() {

    // Set up accordion functionality for H3 and P tags
    setupAccordion();

  });



  function setupAccordion() {
    // Find all H3 tags (questions)
    const h3Elements = document.querySelectorAll('h3');

    h3Elements.forEach((h3, index) => {
      // Add click handler to H3
      h3.style.cursor = 'pointer';
      h3.setAttribute('tabindex', '0');
      h3.setAttribute('role', 'button');
      h3.setAttribute('aria-expanded', 'false');
      h3.dataset.faqIndex = index;

      // Add click event
      h3.addEventListener('click', function() {
        toggleAccordion(this);
      });

      // Add keyboard support
      h3.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggleAccordion(this);
        }
      });
    });
  }



  function toggleAccordion(h3) {
    const isActive = h3.classList.contains('active');

    if (isActive) {
      // Close accordion
      h3.classList.remove('active');
      h3.setAttribute('aria-expanded', 'false');
    } else {
      // Close all other accordions first (optional - remove if you want multiple open)
      document.querySelectorAll('h3.active').forEach(activeH3 => {
        activeH3.classList.remove('active');
        activeH3.setAttribute('aria-expanded', 'false');
      });

      // Open this accordion
      h3.classList.add('active');
      h3.setAttribute('aria-expanded', 'true');
    }
  }



})();
